import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  ProctoringExamEventSchedule,
  ProctoringExamEventScheduleFilters,
} from '@exam-center/proctoring-exam-event-schedule';
import { Flex, PaperSection, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ProctoringPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.PROCTORING.DETAILS.VIEW,
        APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW,
        APP_PERMISSIONS.PROCTORING.E_KYC.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <Flex sx={(theme) => ({ p: theme.spacing(6), justifyContent: 'space-between' })}>
          <Text variant='h1'>จัดการทดสอบ</Text>
        </Flex>
        <Flex sx={(theme) => ({ flex: 1, p: theme.spacing(6) })}>
          <PaperSection title='รายการคุมสอบที่ได้รับมอบหมาย'>
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                gap: theme.spacing(6),
                p: theme.spacing(6),
              })}
            >
              <ProctoringExamEventScheduleFilters />
              <ProctoringExamEventSchedule />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
